export const GET_PERMISSIONS = 'providers/workforce/Permissions/GET_PERMISSIONS';
